"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _SiteFooterDesktop = require("./components/SiteFooterDesktop");

var _SiteFooterMobile = require("./components/SiteFooterMobile");

var _SiteFooterTablet = require("./components/SiteFooterTablet");

var _urls = require("../urls");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SiteFooter = function SiteFooter() {
  var aboutWagLinks = _utils.helper.attachQueryStringToRoutes(_urls.aboutWagLinksData);

  var legalLinks = _utils.helper.attachQueryStringToRoutes(_urls.legalLinksData);

  var lifestyleLinks = _utils.helper.attachQueryStringToRoutes(_urls.lifestyleLinksData);

  var resourcesLinks = _utils.helper.attachQueryStringToRoutes(_urls.resourcesLinksData);

  var securityLinks = _utils.helper.attachQueryStringToRoutes(_urls.securityLinksData);

  var topWagCitiesLinks = _utils.helper.attachQueryStringToRoutes(_urls.topWagCitiesLinksData);

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_SiteFooterMobile.SiteFooterMobile, {
    data: {
      aboutWagLinks: aboutWagLinks,
      legalLinks: legalLinks,
      lifestyleLinks: lifestyleLinks,
      resourcesLinks: resourcesLinks,
      securityLinks: securityLinks,
      topWagCitiesLinks: topWagCitiesLinks
    },
    display: ['block', 'none']
  }), _react["default"].createElement(_SiteFooterTablet.SiteFooterTablet, {
    data: {
      aboutWagLinks: aboutWagLinks,
      legalLinks: legalLinks,
      lifestyleLinks: lifestyleLinks,
      resourcesLinks: resourcesLinks,
      securityLinks: securityLinks,
      topWagCitiesLinks: topWagCitiesLinks
    },
    display: ['none', 'block', 'none']
  }), _react["default"].createElement(_SiteFooterDesktop.SiteFooterDesktop, {
    data: {
      aboutWagLinks: aboutWagLinks,
      legalLinks: legalLinks,
      lifestyleLinks: lifestyleLinks,
      resourcesLinks: resourcesLinks,
      securityLinks: securityLinks,
      topWagCitiesLinks: topWagCitiesLinks
    },
    display: ['none', 'none', 'block']
  }));
};

exports.SiteFooter = SiteFooter;